export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    //const portfolioItems = document.querySelectorAll('.portfolio-item')
    //const heroContent = document.querySelector('.hero__content .container')

    const sectionIntro = document.querySelector('.section--intro')

    window.addEventListener('scroll', () => {
      if (window.scrollY >= sectionIntro.offsetTop) {
        document.body.classList.add('show-actions')
      } else {
        document.body.classList.remove('show-actions')
      }
    })

    /*
    if (portfolioItems) {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        portfolioItems.forEach((portfolioItem, i) => {
          portfolioItem.style.transitionDelay = `${++i * 0.1}s`
        })
      }
    }
    */

    /*
    if (heroContent) {
      const heroHeader = heroContent.children[0]
      const heroDescription = heroContent.children[1]
      const splitHeader = heroHeader.innerHTML.split(' ')
      const words = []

      if (heroHeader) {
        splitHeader.forEach((header, i) => {
          words.push(`<span class="hero__word animate animate--x" style="animation-delay:${++i * 0.2}s">${header}</span>`)
        })

        heroHeader.classList.add('hero__header', `has-${words.length}`)
        heroHeader.innerHTML = words.join('')
      }

      if (heroDescription) {
        heroDescription.classList.add('animate', 'animate--y')
      }
    }
    */
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js